export default [
  {
    path: 'account-trend',
    name: 'settings-account-trend',
    meta: {
      requiredPrivileges:  ["System Settings"]
    },
    component: () =>
      import('@/modules/global-settings/shared/views/AccountTrend.vue')
  },
  {
    path: 'risk-factor-settings',
    name: 'settings-risk-factor-settings',
    meta: {
      requiredPrivileges:  ['System Settings']
    },
    component: () =>
      import('@/modules/global-settings/shared/views/RiskFactor.vue')
  },
  {
    path: 'financial-report-types',
    name: 'financial-report-types',
    component: () => 
      import('@/modules/global-settings/shared/views/FinancialReportTypes.vue')
  },
  {
    path: 'notification-management',
    name: 'notification-management',
    meta: {
      requiredPrivileges: ["System Settings"]
    },
    component: () =>
      import(
        '@/modules/global-settings/system/views/NotificationManagement.vue'
      )
  }
];
